import SSRIcon from "@ingka/ssr-icon";
import pathGrid from "@ingka/ssr-icon/paths/grid";
import pathDataChart from "@ingka/ssr-icon/paths/data-chart";
import pathInformationCircle from "@ingka/ssr-icon/paths/information-circle";
import pathSnowflake from "@ingka/ssr-icon/paths/snowflake";
import pathFlame from "@ingka/ssr-icon/paths/flame";
import pathFlag from "@ingka/ssr-icon/paths/flag";
import pathFlagFilled from "@ingka/ssr-icon/paths/flag-filled";
import pathArrowPairSquarepath from "@ingka/ssr-icon/paths/arrow-pair-squarepath";
import styles from "./BottomNav.module.css";

interface BottomNavProps {
    currentPage: "top" | "analysis" | null;
    onNavigate: (path: "/top" | "/analysis") => void;
    onHelp: () => void;
    isProd: boolean;
    warm: boolean;
    remaining: string;
    onToggleWarm: () => void;
    onSettings: () => void;
    settingsActive: boolean;
    updateAvailable: boolean;
    onReload: () => void;
}

export function BottomNav({
    currentPage,
    onNavigate,
    onHelp,
    isProd,
    warm,
    remaining,
    onToggleWarm,
    onSettings,
    settingsActive,
    updateAvailable,
    onReload,
}: BottomNavProps) {
    return (
        <nav className={styles.bottomNav} aria-label="Primary">
            <button
                type="button"
                className={`${styles.item} ${currentPage === "top" ? styles.active : ""}`}
                onClick={() => onNavigate("/top")}
                aria-current={currentPage === "top" ? "page" : undefined}
            >
                <SSRIcon paths={pathGrid} className={styles.icon} />
                <span className={styles.label}>Top</span>
            </button>
            <button
                type="button"
                className={`${styles.item} ${currentPage === "analysis" ? styles.active : ""}`}
                onClick={() => onNavigate("/analysis")}
                aria-current={currentPage === "analysis" ? "page" : undefined}
            >
                <SSRIcon paths={pathDataChart} className={styles.icon} />
                <span className={styles.label}>Analysis</span>
            </button>
            {currentPage && (
                <button type="button" className={styles.item} onClick={onHelp}>
                    <SSRIcon paths={pathInformationCircle} className={styles.icon} />
                    <span className={styles.label}>Help</span>
                </button>
            )}
            {!isProd && (
                <button
                    type="button"
                    className={`${styles.item} ${warm ? styles.warm : ""}`}
                    onClick={onToggleWarm}
                >
                    <SSRIcon paths={warm ? pathFlame : pathSnowflake} className={styles.icon} />
                    <span className={styles.label}>{warm ? remaining || "Warm" : "Idle"}</span>
                </button>
            )}
            {!isProd && (
                <button
                    type="button"
                    className={`${styles.item} ${settingsActive ? styles.active : ""}`}
                    onClick={onSettings}
                    aria-current={settingsActive ? "page" : undefined}
                >
                    <SSRIcon paths={settingsActive ? pathFlagFilled : pathFlag} className={styles.icon} />
                    <span className={styles.label}>Flags</span>
                </button>
            )}
            {updateAvailable && (
                <button
                    type="button"
                    className={`${styles.item} ${styles.update}`}
                    onClick={onReload}
                    title="A new version is available — tap to reload"
                >
                    <SSRIcon paths={pathArrowPairSquarepath} className={styles.icon} />
                    <span className={styles.label}>Update</span>
                </button>
            )}
        </nav>
    );
}
